// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"card_cardContainer__3qfXe","title":"card_title__3P20m","inActive":"card_inActive__Gg7jt"};